import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Specialty } from "@/modules/administration/features/EmployeeDirectoryManagement/api/Specialty/fetchSpecialties/types";
import SpecialtyForm, {
  SpecialtyFormValues,
} from "@/modules/administration/features/EmployeeDirectoryManagement/components/Specialty/SpecialtyForm/SpecialtyForm";

interface EditSpecialtyDrawerProps {
  specialty: Specialty | null;
  loading: boolean;
  onClose: () => void;
  onSubmit: (values: SpecialtyFormValues) => void;
}

const EditSpecialtyDrawer: React.FC<EditSpecialtyDrawerProps> = ({
  specialty,
  loading,
  onClose,
  onSubmit,
}) => {
  const isOpen = specialty !== null;

  return (
    <Transition.Root as={Fragment} show={isOpen}>
      <Dialog className="relative z-40" onClose={onClose}>
        <Transition.Child>
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <Transition.Child>
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col bg-white dark:bg-slate-900 shadow-xl">
                    <div className="flex items-center justify-between px-4 py-4 bg-primary">
                      <Dialog.Title className="text-lg font-medium text-white">
                        Edit Specialty
                      </Dialog.Title>
                      <button
                        className="text-white"
                        onClick={onClose}
                        type="button"
                      >
                        <XMarkIcon className="h-6 w-6" />
                      </button>
                    </div>

                    <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
                      {specialty && (
                        <SpecialtyForm
                          initialData={{ name: specialty.name }}
                          loading={loading}
                          onSubmit={onSubmit}
                          submitLabel="Save Changes"
                        />
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default EditSpecialtyDrawer;
